import { render, staticRenderFns } from "./voucherCollectionCenter.vue?vue&type=template&id=57674dfd&scoped=true&"
import script from "./voucherCollectionCenter.vue?vue&type=script&lang=js&"
export * from "./voucherCollectionCenter.vue?vue&type=script&lang=js&"
import style0 from "./voucherCollectionCenter.vue?vue&type=style&index=0&id=57674dfd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57674dfd",
  null
  
)

export default component.exports